import styled from "styled-components"

export const SimpleBannerStyles = styled.section`
  height: 70vh;
  min-height: 460px;
  position: relative;
  padding: var(--gap) var(--borderSpacing);
  background-color: var(--color-ink-pure);

  .container {
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    max-width: 1320px;
  }

  .banner__image,
  .gradient {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
  }

  /* warm amber duotone */
  .banner__image img {
    filter: sepia(0.85) saturate(1.7) hue-rotate(-12deg) brightness(0.46)
      contrast(1.05);
  }

  .gradient {
    background: linear-gradient(
        to top,
        rgba(11, 10, 8, 0.97) 0%,
        rgba(11, 10, 8, 0.5) 50%,
        rgba(11, 10, 8, 0.3) 100%
      ),
      radial-gradient(
        at 76% 28%,
        var(--color-glow),
        rgba(11, 10, 8, 0) 52%
      );
  }

  .banner__content {
    position: relative;
    z-index: 2;
    width: 100%;
    padding-bottom: clamp(0.5rem, 4vh, 3rem);

    @media (min-width: 768px) {
      width: 66vw;
    }

    .eyebrow {
      margin-bottom: 1.25rem;
    }

    h1 {
      margin: 0;
      font-size: var(--bannerTitle);
      line-height: 0.95;
      text-shadow: var(--textShadow);
    }
  }
`
